<template>
    <div class="video-container">
    <the-nav-bar :title="$t('newSettings.kycVideo.katoonTitle')"  ref="nav"/>
    <video-player :video-id="videoId" />
    </div>
  </template>
  
<script>
import TheNavBar from '@/components/the-nav-bar';
import VideoPlayer from '@/components/video-player.vue';
export default {
  components: {
    TheNavBar,
    VideoPlayer,
  },
  data() {
    return {
      videoId: 'kyc_video_katoon01',
    };
  },
};
</script>
  
<style scoped>

.custom-video-player {
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}
</style>